// apiConfig.js

let API_URL;

// if (process.env.NODE_ENV === 'production') {
//   // Use the production URL for the backend API
//   API_URL = "https://your-production-backend-url.com";
// } else {
//   // Use the local URL for the backend API during development
//   API_URL = "http://localhost:8848";
// }

// Use the local URL for the backend API during development
API_URL = "http://localhost:8848";

export default API_URL;
